const squash = (item, oldItem) => {
  if (!oldItem) return item

  let res = {}
  for (let f of [...Object.keys(oldItem), ...Object.keys(item)]) {
    res[f] = (item.hasOwnProperty(f) && item[f] && item[f] !== oldItem[f])
      ? item[f]
      : oldItem[f]
  }
  return res
}

export default squash
